<template>
    <v-row>
      <v-col cols="12">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
        class="m-5"
    ref="form"
    v-model="valid"
    lazy-validation
  >
   
    <v-row >
        <v-col class="d-flex" cols="6" sm="6">
        
        
          <v-autocomplete
          :items="select.driving"
          :item-text="'name'"
          item-key="conductor"
          item-value="id"
          v-model="form.conductor"
          label="Conductor"
          ></v-autocomplete>

      </v-col>
      
      <v-col class="d-flex" cols="6" sm="6">
        
        <v-autocomplete
          :items="vehicle_formating"
          :item-text="'name'"
          item-key="conductor"
          item-value="id"
          v-model="form.vehiculo"
          label="Vehículo"
         ></v-autocomplete>
        
        
      </v-col>
    </v-row>
    

    

    <v-btn
      :disabled="!form.vehiculo||!form.conductor"
      color="primary"
      class="mr-4"
      @click="subirAsignacion" 
      :loading="status"
    >
      Completar Asignación
    </v-btn>

    
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
      
      
    </v-row>
    

</template>
<script>

  import {SubirAsignacion} from '../../../../../../services/team/asignacion'

  export default {
    data: () => ({
      valid: true,
      status: false,
      form:{
          conductor:'',
          vehiculo:'',
      },
      
      
    
    
    }),

    computed: {
        
        select(){
            return this.$store.state.select
        },

        vehicle_formating(){
          return this.$store.getters.select_asignacion_getters;
        }

    },

    watch: {
      images(item){
       return this.imagess.push(item)
      }
    },

    methods: {

      vaciarcampos:function(){

        this.form.conductor = ''
        this.form.vehiculo = ''

      },

      GetImg: function(event) {
            this.images = event.target.files;
      },

      subirAsignacion:function(){
          this.$store.dispatch('LoadingFetchActions', true);
          this.status = true
          SubirAsignacion(this.form).then(response=>{
              this.$store.dispatch('GetAllSelect')
              this.$store.dispatch('GetAsign');
              this.$store.dispatch('GetAllSelect');
              this.vaciarcampos();
              this.$toastr.success('Se ha asignado correctamente');
              this.$store.commit('mutation_loading_charge', false);
              this.$store.dispatch('LoadingFetchActions', false);
              this.status = false
          }).catch(errors=>{
              this.vaciarcampos();
              this.$store.commit('mutation_loading_charge', false);
              this.$store.dispatch('LoadingFetchActions', false);
              console.log(errors);
              this.$toastr.error(errors);
              this.status = false
          });

      },

      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>